import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './alerts.html'

/**
 * Alert route
 *
 * @namespace routes.AdminAlerts
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.alerts.list',
  label: 'ADMIN.ALERTS.TITLE',
  url: '/notifications',
  component: 'tmrAdminAlerts',
  weight: 16,
  resourceType: 'Alert',
  resourceList: {
    searchParameters: [
      'startDate.from',
      'startDate.to',
      'endDate.from',
      'endDate.to',
      'category',
      'target',
      'level',
      'enabled',
      'persistent',
    ],
  },
  params: {
    orderBy: { value: 'END_DATE', type: 'string', squash: true },
  },
  resolve: {
    alertLevels: /*@ngInject*/ tmrAlertLevels => tmrAlertLevels,
    alertTargets: /*@ngInject*/ tmrAlertTargets => tmrAlertTargets,
  },
}

/**
 * Component for {@link routes.tmrAdminAlerts Alert route}
 *
 * @type {ngComponent}
 */
export const tmrAdminAlerts = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings({
    alertLevels: '<',
    alertTargets: '<',
  }),
}
